import type { MetricLog, Metric } from '@/database/types';

export interface ChartDataPoint {
  date: string;
  [metricId: string]: number | string;
}

export function aggregateMetricLogs(
  logs: MetricLog[],
  metric: Metric,
  startDate: Date,
  endDate: Date
): ChartDataPoint[] {
  const map: Record<string, number[]> = {};
  logs.forEach((log) => {
    if (log.metricId !== metric.id) return;
    const dayKey = new Date(log.timestamp).toISOString().split('T')[0];
    if (!map[dayKey]) map[dayKey] = [];
    map[dayKey].push(log.value);
  });

  const chartData: ChartDataPoint[] = [];
  const current = new Date(startDate);

  while (current <= endDate) {
    const dayStr = current.toISOString().split('T')[0];
    const vals = map[dayStr] || [];
    let val: number | null = null;

    if (vals.length > 0) {
      if (metric.aggregationRule === 'sum') {
        val = vals.reduce((a, b) => a + b, 0);
      } else if (metric.aggregationRule === 'average') {
        val = vals.reduce((a, b) => a + b, 0) / vals.length;
      } else {
        val = vals[vals.length - 1];
      }
    }

    if (val !== null) {
      chartData.push({
        date: dayStr,
        [metric.id]: parseFloat(val.toFixed(2)),
      });
    }

    current.setDate(current.getDate() + 1);
  }

  return chartData;
}
